import React from "react";
import "./FixProfileNavbar.css";
import "./ProfileNavbar.css";
import logo from "../../assets/img/logoNew.png";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
// import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import Auth from "../../Auth/Auth";
import "./mobileNavBar.scss";
import DropdownMenu from "react-dd-menu";
import "./react-dd-menu.css";
import { connect } from "react-redux";
import uuid from "react-uuid";
import MakeABooking from "../MakeABooking/MakeABooking";
import { logout } from "../../redux/root.actions";
import { notify } from "react-notify-toast"
import InboxIcon from "../MenuBar/InboxIcon";
import NotificationIcon from "../MenuBar/NotificationIcon";
// import { profileIncomplete } from '../../Components-Pages/Dashboard/CollegeDashboardContents'

class CollegeMobileNavBar extends React.Component {
  constructor(props) {
    super(props);
    this.offset = this.props.offset ? "50px" : "0";
    this.state = {
      isMenuOpen: false,
      viewbookings: props.viewbookings,
    };
  }

  btn_jump_profile = (e) => {
    e.preventDefault();
    this.props.history.push("/Profile");
  };

  btn_jump_invoice = (e) => {
    e.preventDefault();
    this.props.history.push("/InvoiceTable");
  };

  btn_jump_joblist = (e) => {
    e.preventDefault();
    this.props.history.push("/CollegeJobList");
  };

  btn_jump_campus = () => {
    this.props.history.push("/Campus");
  };

  btn_jump_personnel = () => {
    this.props.history.push("/Personnel");
  };

  btn_jump_timetable = () => {
    this.props.history.push("/Timetable");
  };

  btn_jump_calendar = () => {
    this.props.history.push("/CollegeCalendar");
  };

  btn_jump_search = () => {
    this.props.history.push("/SearchTeachers");
  };

  btn_jump_favourites = () => {
    this.props.history.push("/FavouriteTeachers");
  };

  btn_jump_myhires = () => {
    this.props.history.push("/MyHires");
  }

  btn_jump_my_listings = () => {
    // if (!profileIncomplete) {
      this.props.history.push("/MyListings");
    // } else {
      // notify.show('Please add your company logo and courses delivered in your Institution Profile')
    // }
  }

  btn_jump_account = () => {
    this.props.history.push("/CollegeAccount");
  };

  btn_jump_chat = () => {
    window.open("https://readyteacher.atlassian.net/servicedesk/customer/portal/6", "_blank")
  }

  btn_jump_user_manual = () => {
    this.props.history.push("/CollegeUserManual");
  }

  btn_jump_logout = () => {
    Auth.logout();
    this.props.logout();
    let userType = window.localStorage.getItem('userType');
    window.localStorage.clear();
    window.localStorage.setItem('userType', userType);
    this.props.history.push("/LoginAsInstitution");
  };

  toggle = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  close = () => {
    this.setState({ isMenuOpen: false });
  };

  menuItem = (title, icon, onClick) => {
    return (
      <span className={icon ? `mdi mdi-${icon}` : ""} onClick={onClick}>
        <span className={icon ? "item-icon-inner" : ""}>{title}</span>
      </span>
    );
  };

  render() {
    const menuOptions = {
      isOpen: this.state.isMenuOpen,
      close: this.close,
      toggle: (
        <span onClick={this.toggle}>
          <i className="mdi mdi-menu"></i> Menu
        </span>
      ),
      align: "right",
      textAlign: "left",
      size: "md",
      className: "dropdown-menu-fix menu-button mobile-menu",
      animate: false,
      closeOnInsideClick: false,
    };

    const user = this.props.user;

    return (
      <div
        className="top-fix-navbar row profile-navbar menu__header"
        style={{ top: this.offset }}
      >
        <Link title="Ready Teacher" to="/" onClick={this.btn_jump_profile}>
          <img src={logo} alt="logo" className="component-home-logo" />
        </Link>
        <div className="col-md-12 menu-area-container menu-area-container-mobile">
          <div className="menu-area">
            {/* here for the mobile college nav */}
            <MakeABooking />
            {
              this.props.isViewAsPersonnel ? <NotificationIcon role="personnel"/> : <NotificationIcon role="customer"/>
            }
            <InboxIcon />
            <Link to="/CollegeDashboard">
              <Icon
                name="home"
                size="large"
                className="menu-home-icon"
                title="To Dashboard"
              />
            </Link>
            <ul className="nav nav-pills">
              <li>
                <div className="drop-down-box">
                  <DropdownMenu {...menuOptions}>
                    <li key={uuid()}>
                      {/* <AccountBalanceIcon style={{ fontSize: 15 }} />
                      {this.menuItem(
                        "Profile",
                        this.btn_jump_profile
                      )} */}
                      {this.menuItem("Profile", "bank", this.btn_jump_profile)}
                    </li>
                    <li key={uuid()}>
                      {/* <AccountBalanceIcon style={{ fontSize: 15 }} />
                      {this.menuItem(
                        "Profile",
                        this.btn_jump_profile
                      )} */}
                      {this.menuItem("Invoices", "bank", this.btn_jump_invoice)}
                    </li>

                    <li key={uuid()}>
                      <details>
                        <summary>
                          {this.menuItem("Bookings", "calendar-check")}
                        </summary>
                        <li>
                          <div
                            className={
                              this.state.viewbookings
                                ? ""
                                : "menu-item-disabled"
                            }
                            onClick={
                              this.state.viewbookings
                                ? this.btn_jump_calendar
                                : () => { }
                            }
                          >
                            Calendar
                          </div>
                        </li>
                        <li>
                          <div
                            className={
                              this.state.viewbookings
                                ? ""
                                : "menu-item-disabled"
                            }
                            onClick={
                              this.state.viewbookings
                                ? this.btn_jump_joblist
                                : () => { }
                            }
                          >
                            Jobs List
                          </div>
                        </li>
                      </details>
                    </li>

                    <li key={uuid()}>
                      {this.menuItem(
                        "My Vacancies",
                        "briefcase",
                        this.btn_jump_my_listings
                      )}
                    </li>

                    <li key={uuid()}>
                      <details>
                        <summary>
                          {this.menuItem(this.props.user.is_childcare_centre ? "My Educators" : "My Teachers", "account-heart")}
                        </summary>
                        <li key="search">
                          <div onClick={this.btn_jump_search}>
                            {this.props.user.is_childcare_centre ? "Search Educators" : "Search Teachers"}
                          </div>
                        </li>
                        <li key="hires">
                          <div onClick={this.btn_jump_myhires}>
                            My Hires</div>
                        </li>
                        <li key="favourites">
                          <div onClick={this.btn_jump_favourites}>
                            {this.props.user.is_childcare_centre ? "Favourite Educators" : "Favourite Teachers"}
                          </div>
                        </li>
                      </details>
                    </li>

                    <li key={uuid()}>
                      <details>
                        <summary>
                          {this.menuItem(this.props.user.is_childcare_centre ? "Centre Settings" : "Institution Settings", "settings")}
                        </summary>
                        <li>
                          <div onClick={this.btn_jump_campus}>
                            {this.props.user.is_childcare_centre ? "Centres" : "Campus"}
                          </div>
                        </li>
                        <li hidden={this.props.user.role === 'personnel'}>
                          <div onClick={this.btn_jump_personnel}>Personnel</div>
                        </li>
                        <li>
                          <div onClick={this.btn_jump_timetable}>
                            {this.props.user.is_childcare_centre ? "Shifts" : "Timetable"}
                          </div>
                        </li>
                      </details>
                    </li>

                    <li key={uuid()}>
                      {this.menuItem(
                        "My Account",
                        "account-check",
                        this.btn_jump_account
                      )}
                    </li>

                    <li key="get-support">
                      <details>
                        <summary>
                          {this.menuItem(
                            "Get Support",
                            "chat-processing"
                          )}
                        </summary>
                        <li key="helpdesk">
                          <div onClick={this.btn_jump_chat}>Helpdesk</div>
                        </li>
                        <li key="user-manual">
                          <div onClick={this.btn_jump_user_manual}>User Manual</div>
                        </li>
                      </details>
                    </li>

                    <li>
                      {this.menuItem("Logout", "power", this.btn_jump_logout)}
                    </li>
                  </DropdownMenu>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.college.user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CollegeMobileNavBar));
